import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import robloxApi from '../../api/robloxApi';
import robloxUrls from "../../configs/roblox/robloxUrls";
import { TemplateInterface } from "../../store/roblox/templatesSlice";

const PREFIX = 'roblox';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: robloxUrls.templatePath(value.id),
    texture_url: robloxUrls.remoteUrl(value.texture_url),
    thumbnail_url: robloxUrls.remoteUrl(value.thumbnail_url)
  };
}

export const templatesEntity = new schema.Entity(
  'templates',
  {},
  {
    processStrategy
  }
);

export const templateEntity = new schema.Entity(
  'template',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      template: TemplateInterface
    }
    >(response.data.template, templateEntity);
  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      templates: { [key: string]: TemplateInterface };
    }
    >(response.data.templates, [templatesEntity]);

  return {
    templates: normalized.entities?.templates || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchTemplates = createAsyncThunk(
  `${PREFIX}_templates/fetchTemplates`,
  async ({ params }: { params: object; }) => {
    const response = await robloxApi.get(`/onesky/templates`, { params });
    return normalizeCollection(response);
  }
);

export const fetchTemplate = createAsyncThunk(
  `${PREFIX}_templates/fetchTemplate`,
  async (id: number | string) => {
    const response = await robloxApi.get(`/onesky/templates/${id}`);
    return normalizeInstance(response);
  }
);

export const createTemplate = createAsyncThunk(
  `${PREFIX}_templates/createTemplate`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await robloxApi.post(`/onesky/templates`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateTemplate = createAsyncThunk(
  `${PREFIX}_templates/updateTemplate`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await robloxApi.patch(`/onesky/templates/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyTemplate = createAsyncThunk(
  `${PREFIX}_templates/destroyTemplate`,
  async (id: number) => {
    const response = await robloxApi.delete(`/onesky/templates/${id}`);
    return response.data;
  }
);
